import { Box, Card, Chip, Container, Divider, InputAdornment, TextField, Typography } from "@mui/material"
import SearchIcon from '@mui/icons-material/Search';
import React from "react";
import opsloth_warehouse_stock_api from '../../src/utils/opsloth_warehouse_stock_api'
import CMSApi from '../utils/opsloth_cms_service_api'
import getSmallerImgUrl from "../utils/getSmallerImgUrl";

function FindProductByTaobaoId(props: any) {
  const [products, setProducts] = React.useState<any>()
  const searchProducts = async (searchKeyword: string) => {
    const warehouse_products_model = new opsloth_warehouse_stock_api('products')
    const warehouse_prodcuts_res: any = await warehouse_products_model.setFilter({
      taobao_id: { $in: searchKeyword.split(' ') }
    }).setField("jancode jancode_box taobao_id").get()

    const jancode_and_jancode_box: any = []
    warehouse_prodcuts_res.data.forEach((warehouse_product: any) => {
      if (warehouse_product.jancode) {
        jancode_and_jancode_box.push(warehouse_product.jancode)
      }

      if (warehouse_product.jancode_box) {
        jancode_and_jancode_box.push(warehouse_product.jancode_box)
      }
    })

    const product_model = new CMSApi("products")
    const products_res: any = await product_model.setFilter({
      deleted: { $ne: true },
      product_code: { $in: jancode_and_jancode_box },
      product_box: { $in: jancode_and_jancode_box }
    }).get()
    console.log(jancode_and_jancode_box)
    setProducts(products_res.data)
  }

  return <Container>
    <Card sx={{ p: 2 }}>
      <TextField
        placeholder="搜索淘宝ID（款式编码）"
        size="small"
        fullWidth
        onKeyDown={async (event: any) => {
          if (event.keyCode === 13) {
            searchProducts(event.target.value)
          }
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}></TextField>
      {
        products?.map((product: any) => {

          return <Box>
            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
              <Box>
                <img style={{padding:"1em"}} src={getSmallerImgUrl(product.mainImage, 100)}></img>
              </Box>
              <Box sx={{ p: 2 }}>
                <Chip label={product.category} sx={{my:1}}></Chip>
                <Typography>{product?.name_zh}</Typography>
                <Typography>JNACODE:{product?.product_code}</Typography>
                <Typography>JNACODE_BOX:{product?.product_code_box}</Typography>
                {product.price_cny_cn && <Typography>代理版售价：{product.price_cny_cn}元/个</Typography>}
                {product.price_cny_jp && <Typography>日版售价：{product.price_cny_jp}元/个</Typography>}
              </Box>
            </Box>
            <Divider sx={{my:2}}></Divider>
          </Box>
        })
      }
    </Card>
  </Container>
}

export default FindProductByTaobaoId